<template>
  <div class="profile">
    <FixedHeader :showSearch="windowWidth >= 700">
      <b-button
        class="back-button"
        type="is-text"
        icon-left="arrow-left"
        size="is-medium"
        @click="goTo()"
      ></b-button>
      <a @click="goTo()">
        <img
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
    </FixedHeader>
    <div class="content">
      <h2>{{ $t("user.profile") }}</h2>
      <div v-if="!showChangePassword">
        <div class="card image-cropper text-center">
          <div class="card-body">
            <i v-if="!user.photo" class="mdi mdi-account profile"></i>
            <img v-if="user.photo" :src="user.photo" class="card-img profile" />
            <div class="card-img-overlay">
              <button
                class="button is-info is-rounded action-button"
                @click="trigger = true"
              >
                {{ $t("user.changeImage") }}
              </button>
            </div>
          </div>
          <image-cropper
            @completed="handleCompleted"
            @cancel="trigger = false"
            :trigger="trigger"
            :tenant="'pinwallusers'"
            :email="user.email"
            :width="128"
          />
        </div>
        <b-field :label="$t('user.username')">
          <b-input v-model="user.username" disabled />
        </b-field>
        <h3>{{ `Quiz ${$t("user.statistics")}` }}</h3>
        <b-field>
          <div class="list">
            <ul>
              <li
                v-for="item in getQuizOrPollList(user.quiz)"
                :key="item.tenant"
              >
                <h4>{{ `${$t("user.page")} ${item.tenant.capitalize()}` }}</h4>
                <span>{{ `Quiz ${$t("user.played")}: ${item.count}` }}</span>
                <span>{{ `${$t("module.points")}: ${item.points}` }}</span>
              </li>
            </ul>
          </div>
        </b-field>
        <h3>{{ `${$t("module.poll")} ${$t("user.statistics")}` }}</h3>
        <b-field>
          <div class="list">
            <ul>
              <li
                v-for="item in getQuizOrPollList(user.poll)"
                :key="item.tenant"
              >
                <h4>{{ `${$t("user.page")} ${item.tenant.capitalize()}` }}</h4>
                <span>{{
                  `${$t("module.poll")} ${$t("user.participated")}: ${
                    item.count
                  }`
                }}</span>
                <span>{{ `${$t("module.points")}: ${item.points}` }}</span>
              </li>
            </ul>
          </div>
        </b-field>
      </div>
      <b-field
        :label="$t('user.changePassword')"
        :type="{ 'is-danger': errors.has('password') }"
        :message="errors.first('password')"
      >
        <b-input
          type="password"
          v-model="password"
          name="password"
          v-validate="'required'"
          password-reveal
        />
      </b-field>
      <button
        @click="updatePassword"
        class="button is-success is-rounded action-button"
      >
        {{ $t("save.name") }}
      </button>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import FixedHeader from "../components/FixedHeader";
import Footer from "@/components/Footer";
import { goTo } from "../mixins/goTo.js";
import ImageCropper from "../components/core/ImageCropper.vue";

export default {
  name: "Profile",
  components: {
    FixedHeader,
    ImageCropper,
    Footer
  },
  data: () => {
    return {
      uploadUrl: "",
      trigger: false,
      message: "ready",
      showChangePassword: false,
      userprofile: null,
      password: ""
    };
  },
  mixins: [goTo],
  computed: {
    ...mapGetters(["user", "darkMode"])
  },
  methods: {
    ...mapActions(["changePassword", "changePhoto"]),
    ...mapMutations(["setUserPhoto"]),
    handleCompleted(data) {
      this.changePhoto(data).then(() => {
        this.setUserPhoto(data.photo);
        this.trigger = false;
      });
    },
    getQuizOrPollList(item) {
      var list = [];

      if (item) {
        for (var tenant in item) {
          let selectedItem = item[tenant];
          list.push({
            tenant: tenant,
            points: selectedItem.points || 0,
            count: selectedItem.ids.length || 0
          });
        }
      }

      return list;
    },
    updatePassword() {
      this.changePassword({
        token: this.user.access_token,
        password: this.password
      }).then(() => {
        this.$buefy.toast.open({
          message: "Password was successfully changed",
          type: "is-success",
          duration: 4000,
          position: "is-top-right"
        });
        this.goTo();
      });
    }
  },
  created() {
    if (!this.user) {
      this.goTo();
    }
    this.uploadUrl = `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
      process.env.VUE_APP_IDENTITY_API
    }/changeLocalPhoto?token=${this.user.access_token}`;
    this.showChangePassword = this.$route.query.changePassword;
  }
};
</script>
